type ObjectWithTermId = Record<string, any> & {
    term?: {
        id: string
    }
}

export function cleanMissingTermIds<T extends ObjectWithTermId>(array: T[] | undefined) {
    if (!array) return []
    return array.filter((item) => !!item.term?.id)
}